import React from 'react';
import { Goal, ScoringRules, UserTeams } from '../../types';
import { goalKey } from '../../utils/scoringUtils';
import NameLink from '../NameLink/NameLink';

const RANK_CLASSES = ['gold', 'silver', 'bronze'];
const RANK_LABELS = ['🥇', '🥈', '🥉'];

interface FirstLastGoalCardWC26Props {
  goal: Goal;
  match: string;
  matchId: number;
  teamAllocs: UserTeams[];
  // eslint-disable-next-line react/no-unused-prop-types
  scoringRules: ScoringRules;
  title: string;
  points: number;
  playerPhoto?: string;
  index: number;
  secondsMap: Record<string, number>;
}

function FirstLastGoalCardWC26({
  goal, match, matchId, teamAllocs, title, points, playerPhoto, index, secondsMap,
}: FirstLastGoalCardWC26Props) {
  const userTeam = teamAllocs.find(
    (t) => t.team1Id === goal.team.toString() || t.team2Id === goal.team.toString()
  );

  const totalSecs = secondsMap[goalKey(matchId, goal)];
  let timeStr: string;
  if (totalSecs !== undefined) {
    const m = Math.floor(totalSecs / 60);
    const s = totalSecs % 60;
    timeStr = `${m}:${String(s).padStart(2, '0')}'`;
  } else {
    timeStr = goal.extra ? `${goal.time}+${goal.extra}'` : `${goal.time}'`;
  }

  return (
    <div className="first-last-goals-wc26-card">
      <div className={`first-last-goals-wc26-rank ${RANK_CLASSES[index] ?? ''}`}>
        {RANK_LABELS[index] ?? index + 1}
      </div>
      <div className="first-last-goals-wc26-label">
        {title && <span className="first-last-goals-wc26-label-title">{title}</span>}
        {playerPhoto && (
          <img className="first-last-goals-wc26-label-photo" src={playerPhoto} alt={goal.playerName} />
        )}
        <span className="first-last-goals-wc26-label-player">{goal.playerName}</span>
      </div>
      <div className="first-last-goals-wc26-team">
        <img src={goal.teamLogo} alt={goal.teamName} />
        <p>{goal.teamName}</p>
        {userTeam && (
          <span className="first-last-goals-wc26-label-owner">
            <NameLink name={userTeam.name} />
          </span>
        )}
      </div>
      <div className="first-last-goals-wc26-match">{match}</div>
      <div className="first-last-goals-wc26-time">{timeStr}</div>
      <div className={`first-last-goals-wc26-score ${points > 0 ? 'positive' : 'neutral'}`}>
        {points > 0 ? `+${points}` : '-'}
      </div>
    </div>
  );
}

export default FirstLastGoalCardWC26;
